import { render } from "./SignaturesPopup.vue?vue&type=template&id=193a7b77&scoped=true"
import script from "./SignaturesPopup.vue?vue&type=script&lang=js"
export * from "./SignaturesPopup.vue?vue&type=script&lang=js"

import "./SignaturesPopup.vue?vue&type=style&index=0&id=193a7b77&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193a7b77"]])

export default __exports__